module.exports = __webpack_public_path__ + "img/Sign-Out.e2e15c19.svg";